import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class ColorApiClient extends AdvancedApiClient {

    static entityType = "Color"

    constructor(token, id) {
        super();

        this.setEntityType(ColorApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/color/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/color");
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}